import React, { useState } from 'react';
import { useModal } from './ModalContext';
import { ModalProps } from './modal.types';
import { createDynamicComponent } from '../_utils';
import { propsOrComponent } from '../_utils/props-or-component';
import { ActionButtonProps } from '../buttons/Buttons.types';
export type PropsOrComponent<TProps> = ({Component: React.ComponentType<TProps>} & TProps) | TProps;

type ModalTriggerProps = {
  trigger: PropsOrComponent<ActionButtonProps>,
  modal: PropsOrComponent<Omit<ModalProps,"show"|"onClose">>
}

export const ModalTrigger = (props:ModalTriggerProps) => {
  const { showModal } = useModal();
  const { trigger, modal } = props;
  const triggerComponentProps = propsOrComponent({
    ...trigger,onAction:() => showModal(modal as any)});
  const triggerComponent = createDynamicComponent(triggerComponentProps);
  return (
    <div>
      <div className={"ebd-icon"}>
        {triggerComponent}
      </div>
    </div>
  );
};
